export default {
  lang_name: 'Español',
  tab_main: 'Principal', tab_upgrade: 'Mejora', tab_prestige: 'Prestigio', tab_achievement: 'Logros', tab_mission: 'Misión', tab_domination: 'Mundo', tab_settings: 'Config.',
  hud_cps: '/s', hud_boost: 'Boost',
  main_tap_area: '¡TOCA!', main_combo: 'Combo',
  prod_informant: 'Informante', prod_informant_desc: 'Recopilación de intel callejera',
  prod_hacker: 'Hacker', prod_hacker_desc: 'Infiltración de redes',
  prod_disguiser: 'Disfrazador', prod_disguiser_desc: 'Camuflaje humano',
  prod_mindController: 'Controlador Mental', prod_mindController_desc: 'Manipulación de opiniones',
  prod_secretLab: 'Lab. Secreto', prod_secretLab_desc: 'Investigación reptiliana',
  prod_mediaCell: 'Célula Mediática', prod_mediaCell_desc: 'Control de noticias',
  prod_shadowGovt: 'Gob. en la Sombra', prod_shadowGovt_desc: 'Reemplazo de políticos',
  prod_deepBase: 'Base Profunda', prod_deepBase_desc: 'Mega-base subterránea',
  prod_orbitalStation: 'Estación Orbital', prod_orbitalStation_desc: 'Red de vigilancia satelital',
  prod_dimensionGate: 'Portal Dimensional', prod_dimensionGate_desc: 'Invocar fuerzas',
  prod_planetController: 'Control Planetario', prod_planetController_desc: 'Control directo de la Tierra',
  prod_galacticBeacon: 'Faro Galáctico', prod_galacticBeacon_desc: 'Línea directa al HQ',
  prod_locked: 'Desbloquear: ', prod_locked_prestige: 'Prestigio {n}x', prod_locked_time: '{n}min juego',
  milestone_squad: 'Escuadrón', milestone_company: 'Compañía', milestone_battalion: 'Batallón',
  milestone_regiment: 'Regimiento', milestone_division: 'División', milestone_corps: 'Cuerpo',
  click_basic_training: 'Entrenamiento Básico', click_combat_training: 'Entrenamiento de Combate',
  click_psychic_awaken: 'Despertar Psíquico', click_transform: 'Mejora de Transformación',
  click_telepathy: 'Telepatía', click_critical_eye: 'Ojo Crítico',
  click_dimension_sense: 'Sentido Dimensional', click_galaxy_field: 'Campo Galáctico',
  click_lethal_strike: 'Golpe Letal', click_absolute: 'Infiltración Absoluta',
  click_planet_destroyer: 'Destructor Planetario', click_galaxy_finger: 'Dedo del Overlord',
  special_info_network: 'Red de Info', special_info_network_desc: 'Informante y Hacker x2',
  special_perfect_disguise: 'Disfraz Perfecto', special_perfect_disguise_desc: 'Todos los agentes x1.5',
  special_mass_brainwash: 'Lavado de Cerebro Masivo', special_mass_brainwash_desc: 'Control Mental y Media x3',
  special_shadow_network: 'Red Sombría', special_shadow_network_desc: 'Ingreso offline +25%',
  special_underground_empire: 'Imperio Subterráneo', special_underground_empire_desc: 'Todos los agentes x2',
  special_orbital_surveillance: 'Vigilancia Orbital', special_orbital_surveillance_desc: 'Eventos dorados +50%',
  special_dimension_supply: 'Suministro Dimensional', special_dimension_supply_desc: 'Ingreso por toque x5',
  special_galactic_alliance: 'Alianza Galáctica', special_galactic_alliance_desc: '🛸 por segundo x10',
  special_combo_master: 'Maestro del Combo', special_combo_master_desc: 'Límite de combo x3',
  special_time_warp: 'Salto Temporal', special_time_warp_desc: 'Límite offline 12h',
  special_agent_synergy: 'Sinergia de Agentes', special_agent_synergy_desc: '🛸 por segundo x1.5',
  special_massive_infiltration: 'Infiltración Masiva', special_massive_infiltration_desc: '🛸 por segundo x2',
  subtab_click: 'Clic', subtab_special: 'Especial',
  prestige_title: 'Reestructuración', prestige_total_ip: '🛸 total ganado', prestige_gc_gain: '💎 a ganar',
  prestige_gc_current: '💎 actual', prestige_execute: 'Reestructurar',
  prestige_confirm: '¿Reiniciar progreso por {gc} Créditos Galácticos?',
  prestige_ad_bonus: 'Ver anuncio +50% 💎', prestige_requirement: 'Necesitas 10B+ 🛸',
  prestige2_title: 'Reestructuración Galáctica', prestige2_cores_gain: '🔮 a ganar',
  prestige2_cores_current: '🔮 actuales', prestige2_execute: 'Reestructuración Galáctica',
  prestige2_requirement: 'Necesitas 15+ prestigios y 100+ 💎', prestige2_confirm: '¿Reinicio profundo por {cores} Núcleos?',
  pup_galaxy_mult: 'Multiplicador Galáctico', pup_galaxy_mult_desc: 'CPS x1.5 por nivel (se acumula multiplicativamente)',
  pup_infil_accel: 'Aceleración de Infiltración', pup_infil_accel_desc: 'Empezar con 100M 🛸 por nivel tras prestigio',
  pup_tap_enhance: 'Mejora de Toque', pup_tap_enhance_desc: 'Ingreso por toque x2 por nivel (se acumula)',
  pup_offline_expand: 'Expansión Offline', pup_offline_expand_desc: 'Límite recompensa offline +1h/Nv (base 8h)',
  pup_offline_eff: 'Eficiencia Offline', pup_offline_eff_desc: 'Tasa ingreso offline +10%p/Nv (base 50%)',
  pup_agent_discount: 'Descuento de Agente', pup_agent_discount_desc: 'Costo agentes -10% por nivel (máx -50%)',
  pup_auto_click: 'Auto Clic', pup_auto_click_desc: 'Auto-toque 3/seg por nivel (máx 15/seg)',
  pup_golden_luck: 'Suerte Dorada', pup_golden_luck_desc: 'Recompensa evento dorado +20%/Nv (máx +200%)',
  pup_combo_keep: 'Mantener Combo', pup_combo_keep_desc: 'Duración combo +0.5s/Nv (base 2s)',
  pup_quick_start: 'Inicio Rápido', pup_quick_start_desc: 'Obtener 1 de los primeros 5 agentes tras prestigio',
  p2up_galaxy_speed: 'Velocidad Galáctica', p2up_galaxy_speed_desc: '💎 ganados x2 por nivel en prestigio (acumulable)',
  p2up_auto_prestige: 'Auto Prestigio', p2up_auto_prestige_desc: 'Prestigio automático al alcanzar 10B 🛸',
  p2up_permanent: 'Agentes Permanentes', p2up_permanent_desc: 'Conservar primeros 3 tipos de agentes tras prestigio',
  p2up_dimension_accel: 'Aceleración Dimensional', p2up_dimension_accel_desc: 'CPS x5 por nivel (acumulable, permanente)',
  p2up_galaxy_memory: 'Memoria Galáctica', p2up_galaxy_memory_desc: 'Conservar 3 mejoras activas tras prestigio',
  p2up_spacetime: 'Curvatura Espaciotemporal', p2up_spacetime_desc: 'Tasa ingreso offline al 100% (permanente)',
  p2up_automate: 'Automatización Galáctica', p2up_automate_desc: 'Contratar agentes automáticamente (permanente)',
  rank_e: 'Interno', rank_d: 'Agente Junior', rank_c: 'Agente', rank_b: 'Agente Senior',
  rank_a: 'Ejecutivo', rank_s: 'Director', rank_ss: 'Comandante Supremo', rank_sss: 'Overlord Galáctico',
  ach_title: 'Logros', ach_filter_all: 'Todos', ach_filter_tap: 'Toque', ach_filter_resource: 'Recurso',
  ach_filter_producer: 'Productor', ach_filter_prestige: 'Prestigio', ach_filter_time: 'Tiempo',
  ach_filter_special: 'Especial', ach_filter_ad: 'Docs', ach_filter_combo: 'Combo',
  ach_t01: 'Primer Paso', ach_t01_reward: '+1 Poder de Toque', ach_t02: 'Calentamiento', ach_t02_reward: '+5% Poder de Toque',
  ach_t03: 'Agente Constante', ach_t03_reward: '+10% Poder de Toque', ach_t04: 'Maestro del Toque', ach_t04_reward: '+15% Poder de Toque',
  ach_t05: 'Determinación Reptiliana', ach_t05_reward: '+20% Poder de Toque', ach_t06: 'Dedos Galácticos', ach_t06_reward: '+25% Poder de Toque',
  ach_t07: 'Aprendiz de Combo', ach_t07_reward: '+0.5s Combo', ach_t08: 'Maestro del Combo', ach_t08_reward: '+0.5 Límite Combo',
  ach_r01: 'Pequeña Intel', ach_r01_reward: '+5% \u{1F6F8}/s', ach_r02: 'Colector de Intel', ach_r02_reward: '+5% \u{1F6F8}/s',
  ach_r03: 'Bóveda Clasificada', ach_r03_reward: '+5% \u{1F6F8}/s', ach_r04: 'Infiltración Millonaria', ach_r04_reward: '+10% \u{1F6F8}/s',
  ach_r05: 'Agente Billonario', ach_r05_reward: '+10% \u{1F6F8}/s', ach_r06: 'Ops Trillón', ach_r06_reward: '+15% \u{1F6F8}/s',
  ach_r07: 'Imperio Cuatrillón', ach_r07_reward: '+15% \u{1F6F8}/s', ach_r08: 'Océano Galáctico', ach_r08_reward: '+20% \u{1F6F8}/s',
  ach_r09: 'Universo Cósmico', ach_r09_reward: '+20% \u{1F6F8}/s', ach_r10: 'Infiltración Infinita', ach_r10_reward: '+30% \u{1F6F8}/s',
  ach_g01: 'Primera Recluta', ach_g01_reward: 'Informante x1.5', ach_g02: 'Red de Intel', ach_g02_reward: 'Informante x2',
  ach_g03: 'Empieza el Hackeo', ach_g03_reward: 'Hacker x2', ach_g04: 'Ciber Legión', ach_g04_reward: 'Hacker x3',
  ach_g05: 'Maestro del Disfraz', ach_g05_reward: 'Disfrazador x2', ach_g06: 'Red de Lavado', ach_g06_reward: 'Control Mental x2',
  ach_g07: 'Ciencia Loca', ach_g07_reward: 'Lab. Secreto x2', ach_g08: 'Control Mediático', ach_g08_reward: 'Célula Mediática x2',
  ach_g09: 'Gabinete Sombra', ach_g09_reward: 'Gob. en la Sombra x2', ach_g10: 'Imperio Subterráneo', ach_g10_reward: 'Base Profunda x2',
  ach_g11: 'Dominancia Orbital', ach_g11_reward: 'Estación Orbital x2', ach_g12: 'Maestro Galáctico', ach_g12_reward: '\u{1F6F8}/s Total x2',
  ach_p01: 'Primera Reestructuración', ach_p01_reward: '+5 💎 Bonus', ach_p02: 'Sabor del Ciclo', ach_p02_reward: '+10% 💎',
  ach_p03: 'Veterano', ach_p03_reward: '+10% 💎', ach_p04: 'Adicto al Prestigio', ach_p04_reward: '+15% 💎',
  ach_p05: 'Bucle Infinito', ach_p05_reward: '+20% 💎', ach_p06: 'Memoria Galáctica', ach_p06_reward: '+25% 💎',
  ach_p07: 'Reestructuración Galáctica', ach_p07_reward: '+3 🔮 Bonus', ach_p08: 'Señor Dimensional', ach_p08_reward: '+20% 🔮',
  ach_h01: 'Nuevo Recluta', ach_h01_reward: 'Bonus Bienvenida 100 🛸', ach_h02: 'Turno de 1 Hora', ach_h02_reward: '+5% \u{1F6F8}/s',
  ach_h03: 'Medio Día', ach_h03_reward: '+10% \u{1F6F8}/s', ach_h04: 'Vigilancia 24h', ach_h04_reward: 'Offline +2h',
  ach_h05: 'Misión de 3 Días', ach_h05_reward: '\u{1F6F8}/s x1.5', ach_h06: 'Infiltración Semanal', ach_h06_reward: '\u{1F6F8}/s x2',
  ach_s01: 'Humano Sospechoso', ach_s01_reward: '1 Doc', ach_s02: 'Inicio Limpio', ach_s02_reward: 'Título: Agente Temerario',
  ach_s03: 'Todo Adentro', ach_s03_reward: '+10% \u{1F6F8}/s', ach_s04: 'Speed Run', ach_s04_reward: '+10 💎 Bonus',
  ach_s05: 'Cazador Dorado', ach_s05_reward: 'Frecuencia evento -20%', ach_s06: 'Agente Nocturno', ach_s06_reward: '\u{1F6F8}/s nocturno x1.5',
  ach_s07: 'Guerrero F2P', ach_s07_reward: 'Recompensa ad +30%', ach_s08: 'Coleccionista', ach_s08_reward: '\u{1F6F8}/s x3',
  ach_a01: 'Principiante de Ads', ach_a01_reward: '1 Doc', ach_a02: 'Entusiasta de Ads', ach_a02_reward: '2 Docs',
  ach_a03: 'Maestro de Ads', ach_a03_reward: 'Recompensa ad +30%', ach_a04: 'Colector de Docs', ach_a04_reward: 'Efecto doc +20%',
  ach_a05: 'Experto en Docs', ach_a05_reward: 'Efecto doc +50%',
  ach_c01: 'Inicio Combo', ach_c01_reward: '+0.3s Combo', ach_c02: 'En el Ritmo', ach_c02_reward: '+0.1 Mult Combo',
  ach_c03: 'Principiante Dorado', ach_c03_reward: 'Recompensa evento +10%', ach_c04: 'Colector Dorado', ach_c04_reward: 'Frecuencia evento -10%',
  ach_c05: 'Maníaco Diario', ach_c05_reward: 'Recompensa misión +50%',
  golden_intel_leak: '¡Fuga de Intel!', golden_agent_frenzy: '¡Frenesí de Agentes!', golden_money_launder: '¡Lavado de Dinero!',
  golden_facility_boost: '¡Sobremarcha!', golden_supply_drop: '¡Suministro Galáctico!', golden_touch: '¡TOCA!',
  golden_ad_double: 'Ver anuncio para 2x',
  offline_title: 'Informe de Ausencia', offline_elapsed: 'Tiempo transcurrido', offline_earned: '🛸 ganado',
  offline_cap: 'Máx {h}h aplicado', offline_claim: 'Reclamar', offline_double: 'Ver anuncio para 2x ({amount})',
  offline_hours: '{h}h {m}m',
  settings_title: 'Configuración', settings_bgm: 'BGM', settings_sfx: 'SFX', settings_lang: 'Idioma',
  settings_reset: 'Reiniciar Juego', settings_reset_confirm: '¿Borrar TODO el progreso?',
  settings_stats: 'Estadísticas', settings_total_ip: '🛸 Total Ganado', settings_total_taps: 'Toques Totales',
  settings_total_prestiges: 'Prestigios Totales', settings_play_time: 'Tiempo Total', settings_docs_shop: 'Tienda de Docs',
  doc_shop_title: 'Tienda de Docs Clasificados',
  doc_ip_boost: 'Acelerador de Ingresos', doc_ip_boost_desc: '2x produccion 🛸/s por 30 seg',
  doc_mega_tap: 'Entrenamiento de Toque', doc_mega_tap_desc: '3x ingreso por toque por 30 seg',
  doc_auto_click: 'Auto-Infiltrador', doc_auto_click_desc: 'Auto-toque 10/seg por 30 seg',
  doc_instant_golden: 'Llamada Dorada', doc_instant_golden_desc: 'Activar evento dorado al instante',
  doc_timeskip: 'Acelerador Temporal', doc_timeskip_desc: 'Obtener 2 horas de ingresos 🛸 al instante',
  doc_prestige_boost: 'Amplificador Galactico', doc_prestige_boost_desc: '2x 💎 en proximo prestigio',
  doc_prestige_boost_active: '💎 x2 pendiente para proximo prestigio', doc_prestige_boost_active_badge: '✅ Activo',
  ad_offline_double: 'Doble recompensa offline', ad_cps_boost: 'Ingreso/s x10 Boost (15s)',
  ad_prestige_bonus: 'Prestigio +50% 💎', ad_timeskip: 'Salto Temporal (2h)', ad_free_docs: 'Docs Gratis',
  ad_golden_double: 'Doble recompensa dorada', ad_start_boost: 'Pack de Inicio',
  ad_watching: 'Cargando anuncio...', ad_cooldown: 'Disponible en {t}',
  settings_sfx_test: 'Probar SFX', settings_sound_reset: 'Restablecer', settings_sound_reset_done: 'Sonido restablecido',
  num_k: 'K', num_m: 'M', num_b: 'B', num_t: 'T', num_qa: 'Qa', num_qi: 'Qi', num_sx: 'Sx', num_sp: 'Sp', num_oc: 'Oc', num_no: 'No', num_dc: 'Dc',
  mission_title: 'Misiones Diarias',
  mission_claim: 'Reclamar',
  mission_all_complete: 'Bonus por completar todo!',
  mission_clear_label: 'MISI\u00D3N',
  mission_all_clear_label: 'TODO LISTO',
  ach_unlock_label: 'LOGRO',
  mission_diff_easy: 'Facil',
  mission_diff_normal: 'Med',
  mission_diff_hard: 'Duro',
  mission_tap_100: 'Toque Ligero', mission_tap_100_desc: 'Tocar 100 veces',
  mission_tap_300: 'Manos Calientes', mission_tap_300_desc: 'Tocar 300 veces',
  mission_buy_5: 'Recluta Menor', mission_buy_5_desc: 'Comprar 5 productores',
  mission_combo_10: 'Inicio Combo', mission_combo_10_desc: 'Alcanzar 10 combo',
  mission_golden_1: 'Captura Dorada', mission_golden_1_desc: 'Atrapar 1 evento dorado',
  mission_tap_1000: 'Golpe Fuerte', mission_tap_1000_desc: 'Tocar 1.000 veces',
  mission_buy_20: 'Constructor de Escuadron', mission_buy_20_desc: 'Comprar 20 productores',
  mission_combo_50: 'Combo Pro', mission_combo_50_desc: 'Alcanzar 50 combo',
  mission_golden_3: 'Fiebre del Oro', mission_golden_3_desc: 'Atrapar 3 eventos dorados',
  mission_earn_1m: 'Operacion Millon', mission_earn_1m_desc: 'Ganar 1M 🛸',
  mission_tap_5000: 'Maquina de Toques', mission_tap_5000_desc: 'Tocar 5.000 veces',
  mission_buy_50: 'Constructor de Ejercito', mission_buy_50_desc: 'Comprar 50 productores',
  mission_combo_100: 'Dios del Combo', mission_combo_100_desc: 'Alcanzar 100 combo',
  mission_golden_5: 'Maestro Dorado', mission_golden_5_desc: 'Atrapar 5 eventos dorados',
  mission_earn_1b: 'Agente Billonario', mission_earn_1b_desc: 'Ganar 1B 🛸',
  mission_tap_200: 'Dedos rápidos',
  mission_tap_200_desc: 'Toca 200 veces',
  mission_buy_3: 'Primeros reclutas',
  mission_buy_3_desc: 'Compra 3 productores',
  mission_combo_15: 'Combo principiante',
  mission_combo_15_desc: 'Alcanza 15 combo',
  mission_earn_10k: 'Dinero de bolsillo',
  mission_earn_10k_desc: 'Gana 10K 🛸',
  mission_earn_100k: 'Recaudador',
  mission_earn_100k_desc: 'Gana 100K 🛸',
  mission_tap_500: 'Toque constante',
  mission_tap_500_desc: 'Toca 500 veces',
  mission_tap_700: 'Imparable',
  mission_tap_700_desc: 'Toca 700 veces',
  mission_buy_10: 'Líder de equipo',
  mission_buy_10_desc: 'Compra 10 productores',
  mission_combo_30: 'Cadena de combo',
  mission_combo_30_desc: 'Alcanza 30 combo',
  mission_golden_2: 'Doble oro',
  mission_golden_2_desc: 'Atrapa 2 eventos dorados',
  mission_tap_3000: 'Guerrero del toque',
  mission_tap_3000_desc: 'Toca 3.000 veces',
  mission_buy_30: 'Batallón',
  mission_buy_30_desc: 'Compra 30 productores',
  mission_combo_75: 'Combo élite',
  mission_combo_75_desc: 'Alcanza 75 combo',
  mission_golden_4: 'Cazador de oro',
  mission_golden_4_desc: 'Atrapa 4 eventos dorados',
  mission_earn_10m: 'Magnate',
  mission_earn_10m_desc: 'Gana 10M 🛸',
  // Conquest
  cq_title: 'Conquista Mundial',
  cq_progress: 'Conquistado',
  cq_infiltration_power: 'Poder de infiltración',
  cq_active_conquest: 'Infiltrando',
  cq_infiltration_progress: 'Progreso de infiltración',
  cq_time_remaining: 'Tiempo estimado',
  cq_start_infiltration: 'Iniciar infiltración',
  cq_stop_infiltration: 'Detener infiltración',
  cq_no_power_hint: 'Contrata agentes para generar poder de infiltración',
  cq_locked: 'Bloqueado',
  cq_available: 'Disponible',
  cq_conquered: 'Conquistado',
  cq_popup_title: '¡Conquista Completa!',
  cq_popup_desc: 'ha sido conquistado. ¡Construye instalaciones para ser más fuerte!',
  cq_back: 'Volver',
  cq_invest_title: 'Invertir 🛸 para conquistar',
  cq_current_ip: '🛸 actual',
  cq_facilities: 'Instalaciones',
  cq_build: 'Construir',
  cq_upgrade: 'Mejorar',
  cq_next_level: 'Siguiente',
  cq_counter_intel_title: 'Alerta de contraespionaje!',
  cq_counter_intel_text: 'Tu infiltración en {country} ha sido detectada! El progreso se reducirá.',
  cq_defend_ad: 'Ver anuncio para defender',
  cq_accept_loss: 'Aceptar pérdida',
  cq_ending_title: 'Tierra conquistada!',
  cq_ending_text: 'La conspiración reptiliana está completa. Todas las naciones se inclinan ante el imperio de las sombras.',
  cq_ending_time: 'Tiempo de juego',
  cq_ending_prestiges: 'Prestigios',
  cq_ending_total_ip: '🛸 total',
  cq_ending_taps: 'Toques totales',
  cq_ending_continue: 'Seguir jugando',
  cq_egypt: 'Egipto', cq_egypt_desc: 'Bases antiguas de pirámides',
  cq_brazil: 'Brasil', cq_brazil_desc: 'Escondites en la selva amazónica',
  cq_india: 'India', cq_india_desc: 'Infiltración del culto Naga',
  cq_australia: 'Australia', cq_australia_desc: 'Búnkeres subterráneos del desierto',
  cq_japan: 'Japón', cq_japan_desc: 'Operaciones de robo tecnológico',
  cq_korea: 'Corea', cq_korea_desc: 'Brecha en defensa cibernética NIS',
  cq_uk: 'Reino Unido', cq_uk_desc: 'Infiltración real MI5/MI6',
  cq_russia: 'Rusia', cq_russia_desc: 'Operaciones siberianas FSB',
  cq_china: 'China', cq_china_desc: 'La vigilancia más fuerte del mundo',
  cq_usa: 'Estados Unidos', cq_usa_desc: 'CIA/NSA jefe final',
  fac_pyramid_vault: 'Bóveda Pirámide', fac_pyramid_vault_d: '\u{1F6F8}/s +5% por nivel',
  fac_nile_network: 'Red del Nilo', fac_nile_network_d: 'Offline +5% por nivel',
  fac_ancient_lab: 'Lab Antiguo', fac_ancient_lab_d: 'TAP +10% por nivel',
  fac_amazon_hideout: 'Escondite Amazónico', fac_amazon_hideout_d: 'Descuento +2% por nivel',
  fac_samba_broadcast: 'Emisora Samba', fac_samba_broadcast_d: '\u{1F6F8}/s +8% por nivel',
  fac_jungle_lab: 'Lab de la Selva', fac_jungle_lab_d: 'Golden +5% por nivel',
  fac_naga_temple: 'Templo Naga', fac_naga_temple_d: '💎 +5% por nivel',
  fac_bollywood_studio: 'Estudio Bollywood', fac_bollywood_studio_d: 'Offline +8% por nivel',
  fac_caste_network: 'Red de Castas', fac_caste_network_d: '\u{1F6F8}/s +12% por nivel',
  fac_desert_bunker: 'Búnker del Desierto', fac_desert_bunker_d: 'TAP +15% por nivel',
  fac_ayers_signal: 'Señal Ayers', fac_ayers_signal_d: 'Golden +8% por nivel',
  fac_outback_base: 'Base Outback', fac_outback_base_d: '\u{1F6F8}/s +15% por nivel',
  fac_akiba_ai: 'IA Akihabara', fac_akiba_ai_d: '\u{1F6F8}/s +20% por nivel',
  fac_ninja_intel: 'Intel Ninja', fac_ninja_intel_d: 'Descuento +3% por nivel',
  fac_tokyo_tower: 'Torre de Tokio', fac_tokyo_tower_d: '💎 +8% por nivel',
  fac_gangnam_hq: 'HQ Gangnam', fac_gangnam_hq_d: '\u{1F6F8}/s +25% por nivel',
  fac_cyber_command: 'Comando Cibernético', fac_cyber_command_d: 'TAP +25% por nivel',
  fac_kpop_brainwash: 'Lavado K-Pop', fac_kpop_brainwash_d: '💎 +10% por nivel',
  fac_royal_infiltrate: 'Infiltración Real', fac_royal_infiltrate_d: '\u{1F6F8}/s +30% por nivel',
  fac_london_tower: 'Torre de Londres', fac_london_tower_d: 'Offline +15% por nivel',
  fac_mi6_double: 'Agente Doble MI6', fac_mi6_double_d: 'Golden +12% por nivel',
  fac_siberia_base: 'Base Siberiana', fac_siberia_base_d: '\u{1F6F8}/s +40% por nivel',
  fac_kgb_remnant: 'Remanente KGB', fac_kgb_remnant_d: 'Descuento +5% por nivel',
  fac_nuke_bunker: 'Búnker Nuclear', fac_nuke_bunker_d: 'TAP +40% por nivel',
  fac_great_wall: 'Gran Firewall', fac_great_wall_d: '\u{1F6F8}/s +50% por nivel',
  fac_shenzhen_factory: 'Fábrica Shenzhen', fac_shenzhen_factory_d: 'Descuento +8% por nivel',
  fac_panda_spy: 'Red Espía Panda', fac_panda_spy_d: 'Golden +20% por nivel',
  fac_area51: 'Área 51', fac_area51_d: '\u{1F6F8}/s +80% por nivel',
  fac_pentagon: 'Pentágono', fac_pentagon_d: 'TAP +80% por nivel',
  fac_wall_street: 'Wall Street', fac_wall_street_d: '💎 +25% por nivel',

  buy: 'Comprar', max: 'MAX', level: 'Nv.', locked: 'Bloqueado', unlocked: 'Desbloqueado',
  upgrade_locked_prev: 'Aprende la mejora anterior primero',
  condition: 'Condición', cost: 'Costo', owned: 'Poseído', effect: 'Efecto', reward: 'Recompensa',
  close: 'Cerrar', confirm: 'Confirmar', cancel: 'Cancelar',

  // Conquest achievements
  ach_filter_conquest: 'Conquista',
  ach_q01: 'Primera Conquista', ach_q01_reward: '\u{1F6F8}/s +10%',
  ach_q02: 'Triple Amenaza', ach_q02_reward: 'TAP +10%',
  ach_q03: 'Medio Mundo', ach_q03_reward: '💎 +15%',
  ach_q04: 'Siete Banderas', ach_q04_reward: 'Offline +20%',
  ach_q05: 'Dominador Mundial', ach_q05_reward: '\u{1F6F8}/s x3',
  ach_q06: 'Maestro de Instalaciones', ach_q06_reward: '\u{1F6F8}/s x2',
  milestone_next: 'Siguiente',
  settings_conquest: 'Conquista',

  // Currency info
  currency_ip_name: 'Puntos de Infiltración (IP)',
  currency_ip_earn: 'Toca, producción automática, ingresos offline y recompensas de anuncios',
  currency_ip_use: 'Contratar agentes, comprar mejoras, invertir en conquistas',
  currency_gc_name: 'Créditos Galácticos (GC)',
  currency_gc_earn: 'Al hacer prestige (Reestructuración) según IP total acumulado',
  currency_gc_use: 'Comprar mejoras de prestige (multiplicador de producci\u00F3n, eficiencia offline, etc.)',
  currency_cores_name: 'Núcleos Galácticos',
  currency_cores_earn: 'Al hacer 2º prestige (Reestructuración Galáctica) según GC total',
  currency_cores_use: 'Comprar mejoras de 2º prestige (buffs permanentes, automatización, etc.)',
  currency_docs_name: 'Documentos Clasificados',
  currency_docs_earn: 'Misiones diarias, ver anuncios o desbloquear logros',
  currency_docs_use: 'Comprar boosts potentes en la Tienda de Docs (pestaña Misión)',
  currency_how_earn: 'Cómo obtener',
  currency_how_use: 'Cómo usar',

  // Prestige upgrades - conquest
  pup_infiltration_mastery: 'Maestría de Infiltración',
  pup_infiltration_mastery_desc: 'Poder de infiltración total +50%/Nv (máx +500%)',
  pup_agent_network: 'Red de Agentes',
  pup_agent_network_desc: 'Infiltración +5% por cada 100 agentes por nivel',
  pup_quick_infiltration: 'Infiltración en Cadena',
  pup_quick_infiltration_desc: 'Al conquistar: siguiente país +10% progreso/Nv',
  pup_critical_chance: 'Entrenamiento Crítico',
  pup_critical_chance_desc: 'Prob. crítico +3%/Nv (base 10%, máx 50%)',
  pup_critical_damage: 'Poder Crítico',
  pup_critical_damage_desc: 'Daño crítico +1x/Nv (base x3)',

  // Special upgrades - conquest
  special_spy_master: 'Maestro Espía',
  special_spy_master_desc: 'Poder de infiltración total x2',

  ad_income_x5: 'Ingresos de 30min',
  ad_income_x5_desc: '¡Mira un anuncio para obtener\n{amount} 🛸 al instante (30 minutos de ingresos)!',
  ad_tap_x10: 'Toque x10 (10s)',
  ad_tap_x10_desc: '¡Mira un anuncio para aumentar\nel ingreso por toque x10 durante 10 segundos!',
  ad_free_docs_desc: '¡Mira un anuncio para obtener\n1 Documento Clasificado 📜 gratis!',
  ad_prestige_desc: '¡Mira un anuncio para aumentar\nlos ingresos x10 durante 15 segundos!',
  cq_tutorial_title: '🌍 Guía de Conquista Mundial',
  cq_tutorial_text: 'Después de conquistar un país, ¡puedes construir <b>instalaciones</b>!\nMejóralas para obtener bonificaciones permanentes\ncomo <b>IPS, ingreso por toque, ingreso offline</b> y más.\n\nContrata agentes para aumentar el poder de infiltración.',
  rank_promote: 'Ascender',
  rank_promoted: '¡Ascenso completado!',

  // Boss events
  boss_resistance_captain: 'Capitán de la Resistencia',
  boss_resistance_captain_desc: 'Líder de la milicia humana, veterano de combate',
  boss_cia_agent: 'Agente de la CIA',
  boss_cia_agent_desc: 'Operativo encubierto con intel clasificada',
  boss_mib_investigator: 'Investigador MIB',
  boss_mib_investigator_desc: 'Agente de campo de Men In Black',
  boss_un_inspector: 'Inspector de la ONU',
  boss_un_inspector_desc: 'Cazador de conspiraciones internacionales',
  boss_whistleblower: 'Denunciante',
  boss_whistleblower_desc: 'Infiltrado rebelde con pruebas',
  boss_journalist: 'Periodista de Investigación',
  boss_journalist_desc: 'Buscador incansable de la verdad con cámara',
  boss_truth_seeker: 'Buscador de la Verdad',
  boss_truth_seeker_desc: 'Investigador paranormal tras la pista',
  boss_galactic_guardian: 'Guardián Galáctico',
  boss_galactic_guardian_desc: 'Ejecutor cósmico de la ley universal',

  boss_alert: '¡AMENAZA DETECTADA!',
  boss_alert_desc: '¡Un enemigo ha aparecido! ¡Toca para atacar!',
  boss_hp: 'HP',
  boss_tap_attack: '¡TOCA PARA ATACAR!',
  boss_double_damage: '2x DMG (30s)',
  boss_eliminated: '¡ELIMINADO!',
  boss_eliminated_desc: '¡{name} ha sido neutralizado!',
  boss_reward_ip: '+{amount} IP',
  boss_reward_docs: '+{amount} Docs',
  boss_reward_gc: '+{amount} GC',
  boss_reward_boost: 'CPS x3 ({seconds}s)',
  boss_claim: 'Reclamar Recompensa',
  boss_claim_double: '2x Recompensa',
  boss_escaped: '¡ESCAPÓ!',
  boss_escaped_desc: 'El objetivo escapó...',
  boss_revive: 'Reintentar (+20s)',
  boss_phase2: '¡ENFURECIDO!',
  boss_streak: 'Racha: {n}',
  boss_time_remaining: 'Tiempo',
  boss_double_damage_active: '¡2x DMG Activo!',

  // Agent collection
  tab_agent: 'Agentes',
  agent_collection_title: 'Colección de Agentes',
  agent_equipped: 'Equipado',
  agent_empty_slot: 'Vacío',
  agent_obtained: '¡Agente Obtenido!',
  agent_equip: 'Equipar',
  agent_unequip: 'Desequipar',
  agent_locked: '???',
  agent_count: 'x{n}',
  agent_tutorial_title: 'Guia de Coleccion de Agentes',
  agent_tutorial_text: '!Derrota a los <b>jefes</b> para coleccionar cartas de agentes!<br><br>Cada agente tiene un bonus pasivo unico.<br>Toca la carta para equipar agentes.<br><br>Mayor rareza = efectos mas fuertes.<br>El prestigio desbloquea mas ranuras de equipamiento.',

  // Agent effect descriptions
  agent_effect_cps_pct: 'CPS {n}',
  agent_effect_tap_pct: 'TAP {n}',
  agent_effect_conquest_speed: 'Vel. Conquista {n}',
  agent_effect_boss_damage: 'Daño al Jefe {n}',
  agent_effect_golden_chance: 'Evento Dorado {n}',
  agent_effect_offline_pct: 'Ingreso Offline {n}',
  agent_effect_docs_rate: 'Tasa de Docs {n}',
  agent_effect_gc_pct: 'Ganancia GC {n}',
  agent_effect_boss_spawn_reduce: 'Aparición Jefe -{n}',
  agent_effect_prestige_gc_bonus: 'Prestigio GC {n}',
  agent_effect_faction_favor: 'Favor de Facción {n}',

  // Agent names & descriptions (25 agents)
  // Common (10)
  agent_field_spy: 'Espía de Campo',
  agent_field_spy_desc: 'Inteligencia de campo aumenta producción IP +8%',
  agent_code_cracker: 'Descifrador',
  agent_code_cracker_desc: 'Habilidad de descifrado aumenta poder de tap +10%',
  agent_shadow_runner: 'Corredor de Sombras',
  agent_shadow_runner_desc: 'Experiencia en sigilo acelera conquista +10%',
  agent_data_miner: 'Minero de Datos',
  agent_data_miner_desc: 'Recolección de datos aumenta ingreso offline +15%',
  agent_lookout: 'Vigía',
  agent_lookout_desc: 'Ojos agudos aumentan probabilidad de evento dorado +10%',
  agent_doc_thief: 'Ladrón de Docs',
  agent_doc_thief_desc: 'Robo de documentos aumenta adquisición de docs +15%',
  agent_network_bot: 'Bot de Red',
  agent_network_bot_desc: 'Redes automatizadas aumentan CPS +10%',
  agent_safe_cracker: 'Ladrón de Cajas',
  agent_safe_cracker_desc: 'Habilidad de caja fuerte aumenta poder de tap +12%',
  agent_recruit: 'Recluta',
  agent_recruit_desc: 'Luchador novato aumenta daño al jefe +10%',
  agent_comm_officer: 'Oficial de Comunicaciones',
  agent_comm_officer_desc: 'Comunicaciones aumentan favor de facción +10%',

  // Rare (8)
  agent_infiltration_ace: 'As de Infiltración',
  agent_infiltration_ace_desc: 'Infiltrador élite aumenta CPS +20%',
  agent_mind_bender: 'Doblegamentes',
  agent_mind_bender_desc: 'Poderes psíquicos aceleran conquista +25%',
  agent_vault_raider: 'Asaltante de Bóvedas',
  agent_vault_raider_desc: 'Experiencia en bóvedas aumenta ganancia GC +20%',
  agent_signal_jammer: 'Bloqueador de Señal',
  agent_signal_jammer_desc: 'Bloqueo reduce intervalo de aparición de jefe -15%',
  agent_double_agent: 'Agente Doble',
  agent_double_agent_desc: 'Doble lealtad aumenta ingreso offline +30%',
  agent_hive_mind: 'Mente Colmena',
  agent_hive_mind_desc: 'Conciencia colectiva aumenta tasa de docs +25%',
  agent_boss_hunter: 'Cazador de Jefes',
  agent_boss_hunter_desc: 'Rastreador especializado aumenta daño al jefe +25%',
  agent_faction_liaison: 'Enlace de Facción',
  agent_faction_liaison_desc: 'Lazos diplomáticos aumentan favor de facción +25%',

  // Epic (5)
  agent_reptilian_elite: 'Élite Reptiliana',
  agent_reptilian_elite_desc: 'Guerrero élite aumenta CPS +35%',
  agent_galaxy_commander: 'Comandante Galáctico',
  agent_galaxy_commander_desc: 'Autoridad galáctica aumenta ganancia GC +40%',
  agent_dark_secretary: 'Secretario Oscuro',
  agent_dark_secretary_desc: 'Burócrata en las sombras aumenta prestigio GC +20%',
  agent_omega_operative: 'Operativo Omega',
  agent_omega_operative_desc: 'Luchador definitivo aumenta daño al jefe +50%',
  agent_shapeshifter: 'Cambiaformas',
  agent_shapeshifter_desc: 'Maestro de formas aumenta poder de tap +40%',

  // Legendary (2)
  agent_the_overlord: 'El Soberano',
  agent_the_overlord_desc: 'Comandante supremo aumenta todo CPS +50%',
  agent_grand_architect: 'Gran Arquitecto',
  agent_grand_architect_desc: 'Planificador cósmico acelera conquista +60%',
  // Faction system
  faction_status_title: 'Estado de Faccion',
  faction_favorability: 'Favorabilidad',
  faction_tier: 'Nivel {n}',

  // Faction event popup
  faction_event_help: 'Ayudar',
  faction_event_ignore: 'Ignorar',
  faction_event_timer: '{seconds}s restantes',
  faction_event_reward: '+{favor} favor {faction}, -{loss} favor {target}',
  faction_event_ip_reward: '+{amount} IP de recompensa',
  faction_event_ad_bonus: 'Ver Anuncio: +{n} favor {faction}',

  // Faction names
  faction_illuminati: 'Illuminati',
  faction_illuminati_desc: 'Gobernantes humanos secretos que manipulan desde las sombras',
  faction_grey: 'Alienígenas Grises',
  faction_grey_desc: 'Especie extraterrestre que comparte tecnología',
  faction_mib: 'Resistencia MIB',
  faction_mib_desc: 'Organización humana secreta que lucha contra la influencia alienígena',

  // Faction bonus descriptions
  faction_illuminati_bonus1: 'CPS +10%',
  faction_illuminati_bonus2: 'CPS +15%',
  faction_illuminati_bonus3: 'Vel. Conquista +20%',
  faction_grey_bonus1: 'Toque +15%',
  faction_grey_bonus2: 'Toque +20%',
  faction_grey_bonus3: 'Cookie Dorada +25%',
  faction_mib_bonus1: 'Daño al Jefe +20%',
  faction_mib_bonus2: 'Ingreso Offline +15%',
  faction_mib_bonus3: 'Aparición Jefe -15%',

  // Event titles and descriptions
  event_illu_decode_title: 'Intercepción Clasificada',
  event_illu_decode_desc: 'Los Illuminati están interceptando archivos clasificados del gobierno. ¿Ayudar a decodificarlos?',
  event_illu_stock_title: 'Manipulación del Mercado',
  event_illu_stock_desc: 'Los Illuminati quieren manipular los mercados bursátiles globales. ¿Proporcionar información privilegiada?',
  event_illu_surveillance_title: 'Red de Vigilancia',
  event_illu_surveillance_desc: 'Los Illuminati están construyendo una red de vigilancia secreta. ¿Ayudar en la construcción?',
  event_illu_meeting_title: 'Cumbre Secreta',
  event_illu_meeting_desc: 'Una reunión secreta de los Illuminati en una cumbre de líderes mundiales. ¿Proporcionar seguridad?',
  event_illu_bribe_title: 'Diplomacia Alienígena',
  event_illu_bribe_desc: 'Los Illuminati quieren sobornar a un diplomático alienígena. ¿Entregar el paquete?',

  event_grey_experiment_title: 'Investigación Humana',
  event_grey_experiment_desc: 'Los Alienígenas Grises están realizando experimentos con humanos. ¿Vigilar el laboratorio?',
  event_grey_mindcontrol_title: 'Dispositivo de Control Mental',
  event_grey_mindcontrol_desc: 'Los Alienígenas Grises quieren instalar un dispositivo de control mental en una ciudad. ¿Ayudar a construirlo?',
  event_grey_crash_title: 'Recuperación de Choque',
  event_grey_crash_desc: 'Una nave exploradora Gris se estrelló en el desierto. ¿Ayudar a recuperar la tripulación?',
  event_grey_terraform_title: 'Terraformación Secreta',
  event_grey_terraform_desc: 'Los Alienígenas Grises están terraformando secretamente una isla. ¿Proporcionar recursos?',
  event_grey_hack_title: 'Hackeo Satelital',
  event_grey_hack_desc: 'Los Alienígenas Grises quieren hackear la red de satélites de la Tierra. ¿Proporcionar códigos de acceso?',

  event_mib_raid_title: 'Asalto a Puesto Alienígena',
  event_mib_raid_desc: 'MIB está planeando un asalto a un puesto alienígena. ¿Unirse al ataque?',
  event_mib_safehouse_title: 'Descubrimiento de Refugio',
  event_mib_safehouse_desc: 'MIB descubrió un refugio oculto de los Illuminati. ¿Ayudar en el asalto?',
  event_mib_weapons_title: 'Desarrollo de Armas',
  event_mib_weapons_desc: 'MIB está desarrollando armas anti-alienígenas. ¿Proporcionar materiales raros?',
  event_mib_evacuate_title: 'Evacuación de Civiles',
  event_mib_evacuate_desc: 'MIB necesita evacuar civiles de una zona de ataque alienígena. ¿Ayudar?',
  event_mib_expose_title: 'Corrupción al Descubierto',
  event_mib_expose_desc: 'MIB quiere exponer la corrupción de los Illuminati al público. ¿Filtrar los documentos?',

  // Shadow Contact (mid-game ad choices)
  sc_title: 'Contacto en la Sombra',
  sc_accept: 'Aceptar Trato',
  sc_decline: 'Rechazar',
  sc_offer_intel: 'Informe de Inteligencia',
  sc_offer_intel_desc: 'Un topo infiltrado ofrece intel clasificada por valor de {amount} 🛸',
  sc_offer_serum: 'Suero Experimental',
  sc_offer_serum_desc: 'Una muestra de laboratorio alien que amplifica el poder de toque x10 durante 30 segundos',
  sc_offer_tech: 'Tecnologia del Mercado Negro',
  sc_offer_tech_desc: 'Tecnologia alien robada que multiplica los ingresos x10 durante 30 segundos',
  sc_offer_docs: 'Alijo Clasificado',
  sc_offer_docs_desc: 'Un escondite secreto con 3 Documentos Clasificados 📜',
  boss_warning: 'ALERTA',
  boss_warning_sub: 'Un enemigo poderoso se acerca...',
  boss_tutorial_title: '¡Pelea de Jefe!',
  boss_tutorial_text: '¡Un jefe ha aparecido! Toca rápido para hacer daño antes de que se acabe el tiempo.<br><br>Derrota jefes para ganar <b>IP, Docs y Cartas de Agente</b>!<br>Mira un anuncio para <b>2x daño</b>.',
  // === Infiltration Run (generated) ===
  tab_infiltration: "Infiltrate",
  infil_eyebrow: "INFILTRATION OPS",
  infil_title: "Infiltration Run",
  infil_subtitle: "Slip in, climb the ranks, get out clean.",
  infil_tutorial_note: "First run: learn the ropes. Chasing the top rank too hard gets you caught.",
  infil_agent_stats: "Agent Stats",
  infil_highest_career: "Best Career",
  infil_total_runs: "Total Runs",
  infil_total_success: "Successes",
  infil_tradeoff_hint: "Safe = small reward, low rank. Greedy = high detection, high risk. Weigh every choice.",
  infil_start: "Start Infiltration",
  infil_start_tutorial: "Start Tutorial Run",
  infil_cooldown: "Cooldown",
  infil_cancel: "Cancel",
  infil_detection: "Detection",
  infil_step: "Event",
  infil_difficulty: "Diff",
  infil_selecting: "Selecting",
  infil_choice_success: "SUCCESS",
  infil_choice_fail: "FAILED",
  infil_roll: "Roll",
  infil_next: "Next",
  infil_to_extraction: "To Extraction",
  infil_extraction_cat: "FINAL STEP",
  infil_extraction_title: "Extraction",
  infil_extraction_desc: "All events cleared. Slip out now — the lower your detection, the safer.",
  infil_attempt_extraction: "Attempt Extraction",
  infil_final_chance: "Extraction Chance",
  infil_result_success: "INFILTRATION SUCCESS",
  infil_result_fail: "CAUGHT",
  infil_result_success_sub: "You slipped out and secured a cover career.",
  infil_result_fail_sub: "Security caught you. Nothing gained this time.",
  infil_docs: "Docs",
  infil_cleared: "Cleared",
  infil_career_earned: "Career Secured",
  infil_fail_note: "No reward. A short cooldown before the next run.",
  infil_retry_ad: "Watch Ad: Second Chance",
  infil_retry_title: "Second Chance",
  infil_retry_desc: "Watch a short ad to lower your detection and retry the extraction once.",
  infil_retry_confirm: "Watch Ad",
  infil_close: "Close",
  infil_stat_disguise: "Disguise",
  infil_stat_combat: "Combat",
  infil_stat_hacking: "Hacking",
  infil_stat_charisma: "Charisma",
  infil_stat_none: "No Check",
  infil_tag_safe: "SAFE",
  infil_tag_risky: "RISKY",
  infil_tag_aggressive: "ALL-IN",
  infil_career_cleaner: "Cleaner",
  infil_career_guard: "Guard",
  infil_career_clerk: "Clerk",
  infil_career_manager: "Manager",
  infil_career_executive: "Executive",
  infil_career_director: "Director",
  infil_career_warrior: "Warrior",
  infil_career_none: "None",
  infil_ev_patrol_cat: "Infiltration Case / Corporate State",
  infil_ev_patrol_title: "Patrol Approaching",
  infil_ev_patrol_desc: "A security patrol is heading straight for you. How do you react?",
  infil_ch_patrol_a_label: "Wait in the shadows",
  infil_ch_patrol_a_desc: "Hold your breath until they pass. Safe, but you lose time.",
  infil_ch_patrol_b_label: "Greet them as staff",
  infil_ch_patrol_b_desc: "Nod politely in your cover identity and walk past.",
  infil_ch_patrol_c_label: "Take them down",
  infil_ch_patrol_c_desc: "Ambush the patrol and force through. Big reward, big risk.",
  infil_ev_security_check_cat: "Infiltration Case / Corporate State",
  infil_ev_security_check_title: "Security Checkpoint",
  infil_ev_security_check_desc: "A manned checkpoint blocks the corridor ahead.",
  infil_ch_security_check_a_label: "Find a side route",
  infil_ch_security_check_a_desc: "Quietly slip down an adjacent passage.",
  infil_ch_security_check_b_label: "Show forged pass",
  infil_ch_security_check_b_desc: "Present a well-made forged access pass.",
  infil_ch_security_check_c_label: "Hack the scanner",
  infil_ch_security_check_c_desc: "Breach the scanner terminal and kill the alarm.",
  infil_ev_informant_cat: "Infiltration Case / Corporate State",
  infil_ev_informant_title: "Recruit an Informant",
  infil_ev_informant_desc: "An insider might hand over classified files — for a price.",
  infil_ch_informant_a_label: "Take the anonymous tip",
  infil_ch_informant_a_desc: "Check the drop box without making contact.",
  infil_ch_informant_b_label: "Persuade the insider",
  infil_ch_informant_b_desc: "Win over the staffer with smooth talk.",
  infil_ch_informant_c_label: "Strong-arm the files",
  infil_ch_informant_c_desc: "Threaten them into surrendering the data.",
  infil_ev_cctv_cat: "Infiltration Case / Corporate State",
  infil_ev_cctv_title: "Bypass the CCTV",
  infil_ev_cctv_desc: "A ceiling of cameras sweeps the whole hall.",
  infil_ch_cctv_a_label: "Move through blind spots",
  infil_ch_cctv_a_desc: "Creep slowly along the camera blind spots.",
  infil_ch_cctv_b_label: "Loop the feed",
  infil_ch_cctv_b_desc: "Splice a fake loop into the surveillance feed.",
  infil_ch_cctv_c_label: "Smash the cameras",
  infil_ch_cctv_c_desc: "Wreck the cameras and rush past.",
  infil_ev_fake_id_cat: "Infiltration Case / Corporate State",
  infil_ev_fake_id_title: "ID Inspection",
  infil_ev_fake_id_desc: "Guards are checking every ID in a long queue.",
  infil_ch_fake_id_a_label: "Leave the queue",
  infil_ch_fake_id_a_desc: "Quietly drop out and find another way.",
  infil_ch_fake_id_b_label: "Present forged ID",
  infil_ch_fake_id_b_desc: "Pass the checkpoint with a crafted forgery.",
  infil_ch_fake_id_c_label: "Sweet-talk the guard",
  infil_ch_fake_id_c_desc: "Talk your way past with slick charm.",
  infil_ev_parking_cat: "Infiltration Case / Corporate State",
  infil_ev_parking_title: "Underground Parking",
  infil_ev_parking_desc: "The garage is your way in, but a guard patrols it.",
  infil_ch_parking_a_label: "Hide behind vehicles",
  infil_ch_parking_a_desc: "Tuck yourself between parked cars.",
  infil_ch_parking_b_label: "Neutralize the guard",
  infil_ch_parking_b_desc: "Silently subdue the garage guard.",
  infil_ch_parking_c_label: "Pose as valet",
  infil_ch_parking_c_desc: "Steal a valet uniform and stroll in.",
  infil_ev_server_room_cat: "Infiltration Case / Corporate State",
  infil_ev_server_room_title: "Server Room Breach",
  infil_ev_server_room_desc: "The core data sits behind a hardened server-room door.",
  infil_ch_server_room_a_label: "Crawl the vents",
  infil_ch_server_room_a_desc: "Take the narrow vents. Slow but safe.",
  infil_ch_server_room_b_label: "Seize admin access",
  infil_ch_server_room_b_desc: "Hijack admin rights to open the room.",
  infil_ch_server_room_c_label: "Force the door",
  infil_ch_server_room_c_desc: "Rip open the security door and barge in.",
  infil_ev_board_meeting_cat: "Infiltration Case / Corporate State",
  infil_ev_board_meeting_title: "Board Meeting Infiltration",
  infil_ev_board_meeting_desc: "Top executives are trading secrets behind closed doors.",
  infil_ch_board_meeting_a_label: "Eavesdrop from the hall",
  infil_ch_board_meeting_a_desc: "Listen quietly from outside the room.",
  infil_ch_board_meeting_b_label: "Pose as consultant",
  infil_ch_board_meeting_b_desc: "Blend in as an outside consultant.",
  infil_ch_board_meeting_c_label: "Storm the room",
  infil_ch_board_meeting_c_desc: "Raid the room and seize every secret. Warrior play.",
  infil_ev_reporter_cat: "Infiltration Case / Corporate State",
  infil_ev_reporter_title: "Shake the Reporter",
  infil_ev_reporter_desc: "A dogged journalist is tailing your every move.",
  infil_ch_reporter_a_label: "Blend into the crowd",
  infil_ch_reporter_a_desc: "Melt into a busy street to lose the tail.",
  infil_ch_reporter_b_label: "Change disguise",
  infil_ch_reporter_b_desc: "Swap outerwear and reverse direction.",
  infil_ch_reporter_c_label: "Feed false leads",
  infil_ch_reporter_c_desc: "Approach first and plant fake information.",
  infil_ev_party_cat: "Infiltration Case / Corporate State",
  infil_ev_party_title: "Crash the Party",
  infil_ev_party_desc: "A gala hides the people you need to reach.",
  infil_ch_party_a_label: "Carry a waiter tray",
  infil_ch_party_a_desc: "Grab an empty tray and pose as service.",
  infil_ch_party_b_label: "Pose as a guest",
  infil_ch_party_b_desc: "Mingle smoothly as an invited guest.",
  infil_ch_party_c_label: "Enter as a VIP",
  infil_ch_party_c_desc: "Dress as a VIP and stride through the front.",
  infil_ev_drone_cat: "Infiltration Case / Corporate State",
  infil_ev_drone_title: "Drone Surveillance",
  infil_ev_drone_desc: "A surveillance drone sweeps the open yard.",
  infil_ch_drone_a_label: "Wait under cover",
  infil_ch_drone_a_desc: "Hide beneath a structure until it passes.",
  infil_ch_drone_b_label: "Jam the signal",
  infil_ch_drone_b_desc: "Jam its comms and blind the drone.",
  infil_ch_drone_c_label: "Shoot it down",
  infil_ch_drone_c_desc: "Down the drone. Sure, but it leaves traces.",
  infil_ev_guard_shift_cat: "Infiltration Case / Corporate State",
  infil_ev_guard_shift_title: "Guard Shift Change",
  infil_ev_guard_shift_desc: "A shift change opens a brief window in the watch.",
  infil_ch_guard_shift_a_label: "Wait for the swap",
  infil_ch_guard_shift_a_desc: "Wait for the gap and move on the change.",
  infil_ch_guard_shift_b_label: "Pose as relief guard",
  infil_ch_guard_shift_b_desc: "Walk into the post as the relief guard.",
  infil_ch_guard_shift_c_label: "Ambush the guard",
  infil_ch_guard_shift_c_desc: "Jump the guard just before the swap.",
  infil_ev_vault_cat: "Infiltration Case / Corporate State",
  infil_ev_vault_title: "The Secret Vault",
  infil_ev_vault_desc: "A hidden vault holds the crown-jewel documents.",
  infil_ch_vault_a_label: "Skip the vault",
  infil_ch_vault_a_desc: "Leave the vault and grab only your target.",
  infil_ch_vault_b_label: "Crack the e-lock",
  infil_ch_vault_b_desc: "Hack the electronic lock and open it.",
  infil_ch_vault_c_label: "Blow the vault",
  infil_ch_vault_c_desc: "Blast it open and grab everything. Top reward.",
  infil_ev_vaccine_cat: "Infiltration Case / Corporate State",
  infil_ev_vaccine_title: "Vaccination Cover",
  infil_ev_vaccine_desc: "A pop-up clinic is the perfect cover to get inside.",
  infil_ch_vaccine_a_label: "Join the queue",
  infil_ch_vaccine_a_desc: "Line up as an ordinary patient.",
  infil_ch_vaccine_b_label: "Wear a medic gown",
  infil_ch_vaccine_b_desc: "Put on a medic gown and walk inside.",
  infil_ch_vaccine_c_label: "Impersonate the chief",
  infil_ch_vaccine_c_desc: "Pose as the director and dismiss the staff.",
  infil_ev_broadcast_cat: "Infiltration Case / Corporate State",
  infil_ev_broadcast_title: "Broadcast Control Room",
  infil_ev_broadcast_desc: "The station feed could carry your message — or your evidence.",
  infil_ch_broadcast_a_label: "Read the logs",
  infil_ch_broadcast_a_desc: "Quietly review the broadcast logs only.",
  infil_ch_broadcast_b_label: "Intercept the feed",
  infil_ch_broadcast_b_desc: "Hack the feed and siphon the data.",
  infil_ch_broadcast_c_label: "Pose as live director",
  infil_ch_broadcast_c_desc: "Impersonate the live director and take the room.",
  infil_ev_border_cat: "Infiltration Case / Corporate State",
  infil_ev_border_title: "Border Checkpoint",
  infil_ev_border_desc: "A guarded border stands between you and the target.",
  infil_ch_border_a_label: "Take an unwatched trail",
  infil_ch_border_a_desc: "Cross via an unmonitored back trail.",
  infil_ch_border_b_label: "Persuade the officer",
  infil_ch_border_b_desc: "Talk the inspector out of suspicion.",
  infil_ch_border_c_label: "Pose as a diplomat",
  infil_ch_border_c_desc: "Cross under a diplomatic cover identity.",
  infil_ch_border_d_label: "Ram the barrier",
  infil_ch_border_d_desc: "Smash the barrier with a vehicle and floor it.",
} as const;
